import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import(/* webpackChunkName: "Home" */'./views/Home.vue')
const Playground = () => import(/* webpackChunkName: "Playground" */ './views/Playground.vue')
const Login = () => import(/* webpackChunkName: "Login" */ './views/Login.vue')
const Cadu = () => import(/* webpackChunkName: "Cadu" */ './views/Cadu.vue')
const ErroTela = () => import(/* webpackChunkName: "ErroTela" */ './views/ErroTela.vue')
const MinhaUnimed = () => import(/* webpackChunkName: "MinhaUnimed" */ './views/MinhaUnimed')
const ConsultarUnimed = () => import(/* webpackChunkName: "ConsultarUnimed" */ './views/ConsultarUnimed')
const Pendencia = () => import(/* webpackChunkName: "Pendencia" */ './views/Pendencia')
const Administracao = () => import(/* webpackChunkName: "Administracao" */ './views/Administracao')
const NovaUnimed = () => import(/* webpackChunkName: "NovaUnimed" */ './views/NovaUnimed')
const Dirigentes = () => import(/* webpackChunkName: "Dirigentes" */ './views/Dirigentes')
const TransacaoOnline = () => import(/* webpackChunkName: "NovaUnimed" */ './views/TransacaoOnline')
const Relatiorios = () => import(/* webpackChunkName: "Relatorios" */ './views/Relatorios')

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (localStorage.getItem('auth_cadu')) {
    next()
    return
  }
  next('/erro')
}

const beforeMinhaUnimed = (to, from, next) => {
  if (from.name) {
    localStorage.setItem('paginaPassada', from.name)
  }
  next()
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
      // beforeEnter: ifNotAuthenticated
    },
    {
      path: '/cadu',
      name: 'cadu',
      component: Cadu
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      beforeEnter: ifNotAuthenticated,
      props: true
    },
    {
      path: '/playground',
      name: 'playgroung',
      component: Playground
    },
    {
      path: '/erro',
      name: 'erro',
      component: ErroTela
    },
    {
      path: '/minhaunimed',
      name: 'minhaunimed',
      component: MinhaUnimed,
      props: true,
      beforeEnter: beforeMinhaUnimed
    },
    {
      path: '/consultarUnimed',
      name: 'consultarUnimed',
      component: ConsultarUnimed
    },
    {
      path: '/pendencias',
      name: 'pendencias',
      component: Pendencia
    },
    {
      path: '/administracao',
      name: 'administracao',
      component: Administracao
    },
    {
      path: '/administracao/novaUnimed',
      name: 'novaUnimed',
      component: NovaUnimed
    },
    {
      path: '/dirigentes',
      name: 'dirigentes',
      component: Dirigentes
    },
    {
      path: '/transacaoOnline',
      name: 'transacaoOnline',
      component: TransacaoOnline
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      component: Relatiorios
    }
  ]
})
